import mergeIcon from '../../../../assets/images/TMS/merge.png';
import mergeIconWhite from '../../../../assets/images/TMS/merge-white.png';
import unmergeIcon from '../../../../assets/images/TMS/split.png';
import unmergeIconWhite from '../../../../assets/images/TMS/split-white.png';
import moveTableIcon from '../../../../assets/images/TMS/moveTable.png';
import moveTableIconWhite from '../../../../assets/images/TMS/moveTable-white.png';
import infoIcon from '../../../../assets/images/Fireboard/infoIcon.png';
import infoIconWhite from '../../../../assets/images/TMS/infoIcon-white.png';
import smsIcon from '../../../../assets/images/TMS/sms.png';
import smsIconWhite from '../../../../assets/images/TMS/sms-white.png';
import clearTable from '../../../../assets/images/TMS/clearTable.png';
import clearTableWhite from '../../../../assets/images/TMS/clearTable.png';
import voidCheckIcon from '../../../../assets/images/TMS/voidCheck.png';
import strings from '../../../../globalization';

const Actions = [
  { id: 0, label: strings.checkDetailsLabel, type: 'info', icon: infoIcon, whiteIcon: infoIconWhite },
  { id: 1, label: strings.smsGuestLabel, type: 'sms', icon: smsIcon, whiteIcon: smsIconWhite },
  { id: 2, label: strings.mergeTableLabel, type: 'merge', icon: mergeIcon, whiteIcon: mergeIconWhite },
  { id: 3, label: strings.unmergeTableLabel, type: 'unmerge', icon: unmergeIcon, whiteIcon: unmergeIconWhite },
  { id: 4, label: strings.transferTableLabel, type: 'transfer', icon: moveTableIcon, whiteIcon: moveTableIconWhite },
  { id: 5, label: strings.clearTableLabel, type: 'clearTable', icon: clearTable, whiteIcon: clearTableWhite },
  { id: 6, label: strings.voidCheckLabel, type: 'voidCheck', icon: voidCheckIcon, whiteIcon: voidCheckIcon },
];

const isActionVisible = (selectedItem, type, selectedShape) => {
  const {
    isClearWaitlistEnabled,
    isMoveTableEnabled,
    isVoidCheckEnabled,
  } = selectedItem;
  const { parentStationId, mergedStationIds } = selectedShape || {};
  const disableMerge = parentStationId;
  const unmergeCriteria = parentStationId || (mergedStationIds && mergedStationIds.length > 0);

  switch (type) {
    case 'info':
      return true;
    case 'sms':
      return true;
    case 'unmerge':
      return unmergeCriteria;
    case 'clearTable':
      return isClearWaitlistEnabled;
    case 'transfer':
      return isMoveTableEnabled;
    case 'merge':
      return !disableMerge
    case 'voidCheck':
      return isVoidCheckEnabled;
    default:
      return true;
  }
};

export { Actions, isActionVisible };
